import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'
import { menuVariants } from '../variants/Menu.variants'

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export const MenuItemLabel = ({ className, children }) => {
  return (
    <span className={cn(menuVariants.itemLabel(), 'text-sm font-semibold leading-none tracking-[0.1px]', className)}>
      {children}
    </span>
  )
}

MenuItemLabel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
